import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import Box from "@mui/material/Box";
import { TableContainer, Paper } from "@mui/material";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search } from "../../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search";
import { Get_Hubspot_Emails_By_Company_ID } from "../api/Get_Hubspot_Emails_By_Company_ID";
import { Search_Hubspot_Company_By_Name } from "../api/Search_Hubspot_Company_By_Name";
import { Get_Hubspot_Contacts_By_Company_ID } from "../api/Get_Hubspot_Contacts_By_Company_ID";
import { Get_Hubspot_Company_By_ID } from "../api/Get_Hubspot_Company_By_ID";
import { StaffuseAuth } from "../../../security/StaffuseAuth";

function ViewHubspot({ id, School, setSchool, handleSchoolchange }) {
  const { logout } = StaffuseAuth();

  //This is the state for the Hubspot Company
  const [HubspotCompany, setHubspotCompany] = useState({});
  //This is the state for the Hubspot Contacts
  const [HubspotContacts, setHubspotContacts] = useState({ results: [] });
  //This is the state for the Hubspot Emails
  const [HubspotEmails, setHubspotEmails] = useState({ results: [] });
  //This is the state for the Hubspot Company
  const [FindHubspotCompany, setFindHubspotCompany] = useState("");
  const [ReturnedHubspotCompanies, setReturnedHubspotCompanies] = useState({
    results: [],
  });

  const HubspotContactsProps = [
    "firstname",
    "lastname",
    "email",
    "lastmodifieddate",
  ];

  const ReturnedHubspotCompaniesProps = [
    "name",
    "country",
    "state",
    "city",
    "address",
    "zip",
    "num_associated_contacts",
    "num_associated_notes",
    "num_notes",
    "createdate",
    "hs_lastmodifieddate",
  ];

  useEffect(() => {
    if (
      id !== "AddSchool" &&
      School.HubspotCompanyID &&
      School.HubspotCompanyID !== ""
    ) {
      Get_Hubspot_Emails_By_Company_ID(
        School.HubspotCompanyID,
        setHubspotEmails,
        logout
      );
    }
  }, [School.HubspotCompanyID]);

  useEffect(() => {
    if (
      id !== "AddSchool" &&
      School.HubspotCompanyID &&
      School.HubspotCompanyID !== ""
    ) {
      Get_Hubspot_Company_By_ID(
        School.HubspotCompanyID,
        setHubspotCompany,
        logout
      );
    }
  }, [School.HubspotCompanyID]);

  useEffect(() => {
    if (
      id !== "AddSchool" &&
      School.HubspotCompanyID &&
      School.HubspotCompanyID !== ""
    ) {
      Get_Hubspot_Contacts_By_Company_ID(
        School.HubspotCompanyID,
        setHubspotContacts,
        logout
      );
    }
  }, [School.HubspotCompanyID]);

  const HubspotEmailsProps = [
    "hs_createdate",
    "hs_email_from_email",
    "hs_email_subject",
    "hs_email_to_email",
  ];

  function handleHubspotCompanyIDchange(e, value) {
    e.preventDefault();
    setSchool({ ...School, HubspotCompanyID: value });
  }

  function handleSerachHubspotForCompany(e) {
    e.preventDefault();
    Search_Hubspot_Company_By_Name(
      FindHubspotCompany,
      setReturnedHubspotCompanies,
      logout
    );
  }

  return (
    <>
      {id !== "AddSchool" &&
      School.HubspotCompanyID &&
      School.HubspotCompanyID !== "" ? (
        <section>
          {" "}
          <h2>Hubspot</h2>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                key="HubspotCompanyID"
                name="HubspotCompanyID"
                label="HubspotCompanyID"
                variant="outlined"
                margin="normal"
                fullWidth
                value={School["HubspotCompanyID"]}
                onChange={(e) => handleSchoolchange(e)}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                disabled={true}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>{" "}
          </Grid>
          <h3>Hubspot Company</h3>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                key="HubspotCompanycountry"
                name="HubspotCompanycountry"
                label="HubspotCompanycountry"
                variant="outlined"
                margin="normal"
                fullWidth
                value={
                  HubspotCompany.properties && HubspotCompany.properties.country
                    ? HubspotCompany.properties.country
                    : ""
                }
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                key="HubspotCompanystate"
                name="HubspotCompanystate"
                label="HubspotCompanystate"
                variant="outlined"
                margin="normal"
                fullWidth
                value={
                  HubspotCompany.properties && HubspotCompany.properties.state
                    ? HubspotCompany.properties.state
                    : ""
                }
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                key="HubspotCompanycity"
                name="HubspotCompanycity"
                label="HubspotCompanycity"
                variant="outlined"
                margin="normal"
                fullWidth
                value={
                  HubspotCompany.properties && HubspotCompany.properties.city
                    ? HubspotCompany.properties.city
                    : ""
                }
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                key="HubspotCompanyaddress"
                name="HubspotCompanyaddress"
                label="HubspotCompanyaddress"
                variant="outlined"
                margin="normal"
                fullWidth
                value={
                  HubspotCompany.properties && HubspotCompany.properties.address
                    ? HubspotCompany.properties.address
                    : ""
                }
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                key="HubspotCompanyzip"
                name="HubspotCompanyzip"
                label="HubspotCompanyzip"
                variant="outlined"
                margin="normal"
                fullWidth
                value={
                  HubspotCompany.properties && HubspotCompany.properties.zip
                    ? HubspotCompany.properties.zip
                    : ""
                }
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                key="HubspotCompanynum_associated_contacts"
                name="HubspotCompanynum_associated_contacts"
                label="HubspotCompanynum_associated_contacts"
                variant="outlined"
                margin="normal"
                fullWidth
                value={
                  HubspotCompany.properties &&
                  HubspotCompany.properties.num_associated_contacts
                    ? HubspotCompany.properties.num_associated_contacts
                    : ""
                }
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                key="HubspotCompanynum_notes"
                name="HubspotCompanynum_notes"
                label="HubspotCompanynum_notes"
                variant="outlined"
                margin="normal"
                fullWidth
                value={
                  HubspotCompany.properties &&
                  HubspotCompany.properties.num_notes
                    ? HubspotCompany.properties.num_notes
                    : ""
                }
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                key="HubspotCompanynum_contacted_notes"
                name="HubspotCompanynum_contacted_notes"
                label="HubspotCompanynum_contacted_notes"
                variant="outlined"
                margin="normal"
                fullWidth
                value={
                  HubspotCompany.properties &&
                  HubspotCompany.properties.num_contacted_notes
                    ? HubspotCompany.properties.num_contacted_notes
                    : ""
                }
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                key="HubspotCompanyaddress"
                name="HubspotCompanyaddress"
                label="HubspotCompanyaddress"
                variant="outlined"
                margin="normal"
                fullWidth
                value={
                  HubspotCompany.properties && HubspotCompany.properties.address
                    ? HubspotCompany.properties.address
                    : ""
                }
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                key="HubspotCompanyzip"
                name="HubspotCompanyzip"
                label="HubspotCompanyzip"
                variant="outlined"
                margin="normal"
                fullWidth
                value={
                  HubspotCompany.properties && HubspotCompany.properties.zip
                    ? HubspotCompany.properties.zip
                    : ""
                }
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
          <h3>Hubspot Contacts</h3>
          <Grid container spacing={2}>
            <Box
              component="main"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                maxWidth: "95%",
                maxHeight: "400px",
                flexGrow: 1,
                p: 1,
                marginLeft: "10px",
              }}
            >
              <TableContainer
                component={Paper}
                sx={{
                  width: "100%",
                  margin: "0 auto",
                  overflow: "auto",
                }}
              >
                <Table
                  aria-label="simple table"
                  sx={{
                    border: "1px solid #e0e0e0",
                    tableLayout: "fixed",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      {HubspotContactsProps.map((prop) => (
                        <TableCell
                          className="tableCellHeader" // Add this line to include the CSS class
                          align="left"
                          style={{
                            position: "sticky",
                            Top: 0,
                            zIndex: 1,
                            fontWeight: "bold", // Make Text bold
                            padding: "8px", // Adjust padding as needed To make cells smaller
                          }}
                        >
                          {prop}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {HubspotContacts.results.map((HubspotContact, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:hover": {
                            backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                            "& .MuiTableCell-root": {
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word", // Adjust padding here to make cells smaller
                            },
                          },
                        }}
                      >
                        {HubspotContactsProps.map((prop) => (
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {HubspotContact.properties[prop]
                              ? HubspotContact.properties[prop]
                              : ""}
                          </TableCell>
                        ))}
                        <TableCell
                          align="left"
                          sx={{
                            padding: "8px",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                          }}
                        >
                          <Link
                            to={`/Staff/LogSchoolEvent/${id}/${HubspotContact.id}`}
                            id
                            target="_blank"
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                            }}
                          >
                            <button>Log Event</button>
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
          <h3>Hubspot Engagements</h3>
          <Grid container spacing={2}>
            <Box
              component="main"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                maxWidth: "95%",
                maxHeight: "400px",
                flexGrow: 1,
                p: 1,
                marginLeft: "10px",
              }}
            >
              <TableContainer
                component={Paper}
                sx={{
                  width: "100%",
                  margin: "0 auto",
                  overflow: "auto",
                }}
              >
                <Table
                  aria-label="simple table"
                  sx={{
                    border: "1px solid #e0e0e0",
                    tableLayout: "fixed",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      {HubspotEmailsProps.map((prop) => (
                        <TableCell
                          className="tableCellHeader" // Add this line to include the CSS class
                          align="left"
                          style={{
                            position: "sticky",
                            Top: 0,
                            zIndex: 1,
                            fontWeight: "bold", // Make Text bold
                            padding: "8px", // Adjust padding as needed To make cells smaller
                          }}
                        >
                          {prop}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {HubspotEmails.results.map((HubspotEmail, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:hover": {
                            backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                            "& .MuiTableCell-root": {
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                              wordBreak: "break-all", // Adjust padding here to make cells smaller
                            },
                          },
                        }}
                      >
                        {HubspotEmailsProps.map((prop) => (
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                              wordBreak: "break-all",
                            }}
                          >
                            {HubspotEmail.properties &&
                            HubspotEmail.properties[prop]
                              ? HubspotEmail.properties[prop]
                              : ""}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </section>
      ) : (
        <section>
          {" "}
          <h2>Hubspot</h2>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                key="FindHubspotCompany"
                name="FindHubspotCompany"
                label="FindHubspotCompany"
                variant="outlined"
                margin="normal"
                fullWidth
                value={FindHubspotCompany}
                onChange={(e) => setFindHubspotCompany(e.target.value)}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{ shrink: true }}
              />
              <Button
                type="submit"
                variant="contained"
                sx={{ mt: 3, ml: 1 }}
                onClick={(e) => handleSerachHubspotForCompany(e)}
              >
                Search
              </Button>
            </Grid>{" "}
          </Grid>
          <h3>Hubspot Companies To Assign</h3>
          <Grid container spacing={2}>
            <Box
              component="main"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                maxWidth: "95%",
                maxHeight: "400px",
                flexGrow: 1,
                p: 1,
                marginLeft: "10px",
              }}
            >
              <TableContainer
                component={Paper}
                sx={{
                  width: "100%",
                  margin: "0 auto",
                  overflow: "auto",
                }}
              >
                <Table
                  aria-label="simple table"
                  sx={{
                    border: "1px solid #e0e0e0",
                    tableLayout: "fixed",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className="tableCellHeader" // Add this line to include the CSS class
                        align="left"
                        style={{
                          position: "sticky",
                          Top: 0,
                          zIndex: 1,
                          fontWeight: "bold", // Make Text bold
                          padding: "8px", // Adjust padding as needed To make cells smaller
                        }}
                      >
                        id
                      </TableCell>
                      {ReturnedHubspotCompaniesProps.map((prop) => (
                        <TableCell
                          className="tableCellHeader" // Add this line to include the CSS class
                          align="left"
                          style={{
                            position: "sticky",
                            Top: 0,
                            zIndex: 1,
                            fontWeight: "bold", // Make Text bold
                            padding: "8px", // Adjust padding as needed To make cells smaller
                          }}
                        >
                          {prop}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ReturnedHubspotCompanies.results.map(
                      (ReturnedHubspotCompany, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:hover": {
                              backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                              "& .MuiTableCell-root": {
                                padding: "8px",
                                wordWrap: "break-word",
                                overflowWrap: "break-word", // Adjust padding here to make cells smaller
                              },
                            },
                          }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                              wordBreak: "break-all",
                            }}
                          >
                            {ReturnedHubspotCompany.id
                              ? ReturnedHubspotCompany.id
                              : ""}
                          </TableCell>
                          {ReturnedHubspotCompaniesProps.map((prop) => (
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                padding: "8px",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                              }}
                            >
                              {ReturnedHubspotCompany.properties &&
                              ReturnedHubspotCompany.properties[prop]
                                ? ReturnedHubspotCompany.properties[prop]
                                : ""}
                            </TableCell>
                          ))}
                          <Button
                            type="submit"
                            variant="contained"
                            sx={{ mt: 3, ml: 1 }}
                            onClick={(e) =>
                              handleHubspotCompanyIDchange(
                                e,
                                ReturnedHubspotCompany.id
                              )
                            }
                          >
                            Assign
                          </Button>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </section>
      )}
    </>
  );
}

export default ViewHubspot;
